module.exports = " <div class=\"label left\"> Configure Generator </div> <svg class=\"arrow left\"> <polygon points=\"0,0 30,47 0,94\"/> </svg> <svg class=\"arrow-big left\"> <polygon points=\"0,0 40,60 0,120\"/> </svg>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/layout/start-arrow.cmp.html
// module id = 862
// module chunks = 1